import { FadeImage } from "./FadeImage";

const BRAND = "/brand/";

// Decorative hand-drawn / doodle brand element (absolutely positioned via className).
export const Decor = ({ name, className = "", style, alt = "" }) => (
  <img
    src={`${BRAND}${name}.png`}
    alt={alt}
    aria-hidden={alt ? undefined : "true"}
    draggable="false"
    style={style}
    className={`pointer-events-none select-none ${className}`}
  />
);

// Polaroid photo frame: white mat + fuchsia offset backing + optional paperclip clipped on the frame edge.
export const Polaroid = ({
  src,
  alt,
  rotate = -2,
  clip = false,
  className = "",
  imgClassName = "w-full h-auto object-cover",
}) => (
  <div
    className={`relative inline-block ${className}`}
    style={{ transform: `rotate(${rotate}deg)` }}
  >
    <div className="polaroid">
      <FadeImage src={src} alt={alt} className={imgClassName} />
    </div>
    {clip && (
      <img
        src={`${BRAND}paperclip.png`}
        alt=""
        aria-hidden="true"
        draggable="false"
        className="pointer-events-none select-none absolute -top-3 right-10 w-14 rotate-[86deg] z-20 drop-shadow-md"
      />
    )}
  </div>
);
